<template>
<div class="modal">
    <div class="modal__header"></div>
    <div class="modal__body">
        <p>
            {{msg}}
        </p>
    </div>
    <div class="modal__footer">
        <Button msg="No" :dark="true" @click.native="cancelModal" />
        <Button msg="Si" @click.native="actionMethod" />
    </div>
</div>
</template>

<script>
import Button from '@/components/Button.vue'
export default {
    props: ['msg', 'action'],
    components: {
        Button
    },
    data: () => {
        return {
            company: 'Generali'
        }
    },
    methods: {
        cancelModal() {
            this.$emit('cancelModal', false)
        },
        async actionMethod() {
            this.$emit('cancelModal', false);
            this.$emit('flowAction');
        }
    }
}
</script>

<style lang="scss" scoped>
img {
    height: 300px;
    width: 80%;
}

.modal {
    top: 120px;
    position: absolute;
    display: flex;
    flex-direction: column;
    border: 1px solid grey;
    height: 200px;
    width: 22%;
    min-width: 375px;
    align-items: center;
    margin-top: 100px;
    background-color: white;
    font-family: Arial;
    text-align: center;

    &__header {
        height: 30px;
        width: 100%;
    }

    &__footer {
        width: 100%;
        display: flex;
        position: absolute;
        bottom: 0;
        justify-content: space-around;
        margin-bottom: 20px;
    }
}

p {
    font-weight: 600;
}
</style>
